import React from 'react';

import componentRenderService from '../services/component-render.service';

import AudioListItemPlayer from './renders/audio-list-item-player';
import AudioRecord from './renders/audio-record';
import PublicProfileCopyToClipboard from './renders/public-profile-copy-to-clipboard';
import UploadImage from './renders/upload-image';

componentRenderService.byQuerySelector('.audio-list-item-player', AudioListItemPlayer);
componentRenderService.byQuerySelector('.page-audio-record', AudioRecord);
componentRenderService.byQuerySelector('.react-public-profile-copy-to-clipboard', PublicProfileCopyToClipboard);
componentRenderService.byQuerySelector('.react-upload-image', UploadImage);
